import { BaseError } from '@dynamic-labs-sdk/client';

type SendBitcoinRawTransactionErrorParams = {
  originalError: unknown;
};

export class SendBitcoinRawTransactionError extends BaseError {
  constructor({ originalError }: SendBitcoinRawTransactionErrorParams) {
    const cause = originalError instanceof Error ? originalError : null;

    super({
      cause,
      code: 'send_bitcoin_raw_transaction_error',
      docsUrl: null,
      name: 'SendBitcoinRawTransactionError',
      shortMessage: 'Failed to send Bitcoin raw transaction',
    });
  }
}
